import { Button } from "@pinkyhead/dovekit";
import { ReactComponent as SearchIcon } from "../../../../assets/icons/regular/search.svg";
import { useNoDataList } from "./NoDataList.hooks";
import { Container, IconContainer } from "./NoDataList.styles";

export const NoDataList = () => {
  const {
    itemType,
    redirectToClaim,
    showClaimButton
  } = useNoDataList()
  return (
    <Container>
      <IconContainer>
        <SearchIcon />
      </IconContainer>
      <h1>No Results Found</h1>
      <p>
        We couldn't find any results based on your search. <br />
        Please try searching with another term.
      </p>
      {showClaimButton &&
        <>
          <p>Would you like to add this profile on DoveMed?</p>
          <Button 
            variant="primary"
            onClick={redirectToClaim}
          >
            Add {itemType} Profile!
          </Button>
        </>
      }
    </Container>
  )
}
